import { put, call, delay } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';
import { OK } from '../../../configs/serverStatusCodes';
import {
  loadHostListFailed,
  loadHostListSuccessful,
  loadHostListBegin,
} from '../actions';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* loadHostList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
    } = payload;
    let pool = {
      limit,
      page,
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool = addFilterQueryWithCondition(filter, pool);
    }
    const url = `${BACKEND_URL}/hosts`;
    yield put(loadHostListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      data.result = data.data;
      yield put(loadHostListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadHostListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadHostListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
